<template>
  <div class="daily-date-picker">
    <div justify="center" align="center">
      <v-row class="pa-0 ma-0">
        <v-col>
          <v-row class="">
            <v-col class="px-1" cols="6" xs="6" sm="4" md="4">
              <div class="d-flex flex-column">
                <small class="text-align-start">{{
                  $t("beginDate") + ":"
                }}</small>
                <DialogDatePicker
                  :label="$t('beginDate') + ':'"
                  :initDate="initBeginDate"
                  @dateResult="beginDate"
                />
              </div>
            </v-col>

            <v-col class="px-1" cols="6" xs="6" sm="4" md="4">
              <div class="d-flex flex-column">
                <small class="text-align-start">{{
                  $t("endDate") + ":"
                }}</small>
                <DialogDatePicker
                  :label="$t('endDate') + ':'"
                  :initDate="initEndDate"
                  @dateResult="endDate"
                />
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="4"
              md="4"
              justify="center"
              align="center"
              class="mt-2 mt-sm-0"
            >
              <div class="d-flex h-100">
                <v-btn
                  class="mt-auto"
                  block
                  color="primary"
                  @click="getResult()"
                  >{{ $t("show") }}</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import DialogDatePicker from "./DialogDatePicker.vue";

export default {
  components: {
    DialogDatePicker,
  },
  mounted() {
    this.getLastPeriod();
  },
  computed: {},
  methods: {
    // getLastPeriod() {
    //   this.$store.dispatch("getLastPeriod").then((result) => {
    //     if (result.type === "success") {
    //       debugger
    //       if (result.data.length > 0) {
    //         debugger
    //         var obj = result.data[0];
    //         this.date = obj.BeginDate;
    //         this.date2 = obj.EndDate;
    //         this.initBeginDate = obj.BeginDate.toString();
    //         this.initEndDate = obj.EndDate;
    //         this.getResult();
    //       }
    //     }
    //   });
    // },
    getResult() {
      this.$emit("getDate", this.date, this.date2);
    },
    beginDate(date) {
      this.date = date;
      if (this.date2) {
        this.getResult();
      }
    },
    endDate(date) {
      this.date2 = date;
      if (this.date) {
        this.getResult();
      }
    },
  },
  data: () => ({
    date: "",
    date2: "",
    initBeginDate: "",
    initEndDate: "",
    modal: false,
    modal2: false,
  }),
};
</script>

<style>
.card {
  background-color: var(--background-card) !important;
}
</style>